var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"rounded-lg",attrs:{"icon":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-badge',{attrs:{"dot":"","overlap":"","value":_vm.badgeVisible}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.mdiCommentProcessingOutline)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }